import form from './form.json';

export default {
  form,
};
